module.exports = __webpack_public_path__ + "static/calogo-783a429f028aed9a1a5a5cb5be8f440a.png";